export default "__VITE_ASSET__BrOlDb4M__"